<div>
    <div>
        <app-nav></app-nav>

        <!--  BEGIN MAIN CONTAINER  -->
        <div class="main-container" id="container">

            <div class="overlay"></div>
            <div class="search-overlay"></div>

            <!--  BEGIN SIDEBAR  -->
            <div class="sidebar-wrapper sidebar-theme">

                <div id="dismiss" class="d-lg-none"><i class="flaticon-cancel-12"></i></div>

                <nav id="sidebar">

                    <!-- <ul class="navbar-nav theme-brand flex-row  text-center">
                        <li class="nav-item theme-logo">
                            <a href="javascript:void(0);">
                                <img src="assets/assets/img/90x90.jpg" class="navbar-logo" alt="logo">
                            </a>
                        </li>
                        <li class="nav-item theme-text">
                            <a href="javascript:void(0);" class="nav-link"> Transecur </a>
                        </li>
                    </ul> -->


                    <ul class="navbar-nav theme-brand flex-row  text-center">
                        <li class="nav-item theme-logo">
                            <a href="javascript:void(0);">
                                <img id="logo_trans" src="/assets/images/logo_2.png"
                                    class="navbar-logo" alt="logo">
                            </a>
                        </li>
                        <li class="nav-item theme-text">
                        </li>
                    </ul>

                    <ul class="list-unstyled menu-categories" id="accordionExample">

                        <li (click)="setActive('11')" class="menu active" id="menu11" *ngIf="token?.permissions?.viewMap">
                            <a routerLink="/map" href="javascript:void(0);" data-toggle="collapse" aria-expanded="true"
                                class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <line x1="22" y1="12" x2="2" y2="12"></line>
                                        <path
                                            d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z">
                                        </path>
                                        <line x1="6" y1="16" x2="6.01" y2="16"></line>
                                        <line x1="10" y1="16" x2="10.01" y2="16"></line>
                                    </svg>
                                    <span> Map </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('0')" class="menu " id="menu0" *ngIf="token?.permissions?.dataEntry">
                            <a routerLink="/entry" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-edit">
                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                                    </svg>
                                    <span> Data Entry </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('1')" class="menu" id="menu1">
                            <a routerLink="/dashboard" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <rect x="1" y="3" width="15" height="13"></rect>
                                        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
                                        <circle cx="5.5" cy="18.5" r="2.5"></circle>
                                        <circle cx="18.5" cy="18.5" r="2.5"></circle>
                                    </svg>
                                    <span> Trips </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('2')" class="menu" id="menu2" *ngIf="token?.permissions?.alertPage">
                            <a routerLink="/alert" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <path
                                            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z">
                                        </path>
                                        <line x1="12" y1="9" x2="12" y2="13"></line>
                                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                    </svg>
                                    <span> Alerts </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('3')" class="menu" id="menu3" *ngIf="token?.permissions?.viewGeofence">
                            <a routerLink="/geofence" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg>
                                    <span> Geofences </span>
                                </div>
                            </a>
                        </li>
                        
                        <li (click)="setActive('4')" class="menu" id="menu4" *ngIf="token?.permissions?.createRoutes">
                            <a routerLink="/routes" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-git-merge"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M6 21V9a9 9 0 0 0 9 9"/>
                                    </svg>
                                    <span> Route </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('5')" class="menu" id="menu5" *ngIf="token?.permissions?.viewAssets">
                            <a routerLink="/asset/list" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <line x1="22" y1="12" x2="2" y2="12"></line>
                                        <path
                                            d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z">
                                        </path>
                                        <line x1="6" y1="16" x2="6.01" y2="16"></line>
                                        <line x1="10" y1="16" x2="10.01" y2="16"></line>
                                    </svg>
                                    <span> Assets </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('6')" class="menu" id="menu6" *ngIf="token?.permissions?.viewUser">
                            <a routerLink="/register/list" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg>
                                    <span> Users </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('7')" class="menu" id="menu7"
                            *ngIf="token?.permissions?.deviceMonitoring">
                            <a routerLink="/device_monitoring/" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
                                        <rect x="9" y="9" width="6" height="6"></rect>
                                        <line x1="9" y1="1" x2="9" y2="4"></line>
                                        <line x1="15" y1="1" x2="15" y2="4"></line>
                                        <line x1="9" y1="20" x2="9" y2="23"></line>
                                        <line x1="15" y1="20" x2="15" y2="23"></line>
                                        <line x1="20" y1="9" x2="23" y2="9"></line>
                                        <line x1="20" y1="14" x2="23" y2="14"></line>
                                        <line x1="1" y1="9" x2="4" y2="9"></line>
                                        <line x1="1" y1="14" x2="4" y2="14"></line>
                                    </svg>
                                    <span> Device Monitoring </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('8')" class="menu" id="menu8" *ngIf="token?.permissions?.cashMonitoring">
                            <a routerLink="/cash_records" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                                    </svg>
                                    <span> Cash Report </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('9')" class="menu" id="menu9"
                            *ngIf="token?.permissions?.viewEventLogs">
                            <a routerLink="/logs" href="javascript:void(0);" data-toggle="collapse" aria-expanded="true"
                                class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="css-i6dzq1">
                                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                        <polyline points="14 2 14 8 20 8"></polyline>
                                        <line x1="16" y1="13" x2="8" y2="13"></line>
                                        <line x1="16" y1="17" x2="8" y2="17"></line>
                                        <polyline points="10 9 9 9 8 9"></polyline>
                                    </svg>
                                    <span> Event Logs </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('10')" class="menu" id="menu10"
                            *ngIf="token?.permissions?.viewEventLogs">
                            <a routerLink="/deviceLogs" href="javascript:void(0);" data-toggle="collapse" aria-expanded="true"
                                class="dropdown-toggle">
                                <div class="">
                                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor"
                                        stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"
                                        class="device-log-icon">
                                        <!-- Device or screen shape -->
                                        <rect x="3" y="4" width="18" height="14" rx="2" ry="2"></rect>
                                        <!-- Log lines inside the screen -->
                                        <line x1="7" y1="8" x2="17" y2="8"></line>
                                        <line x1="7" y1="12" x2="17" y2="12"></line>
                                        <line x1="7" y1="16" x2="13" y2="16"></line>
                                        <!-- Base of the device -->
                                        <rect x="9" y="19" width="6" height="1"></rect>
                                    </svg>
                                    <span> Device Logs </span>
                                </div>
                            </a>
                        </li>

                        <li (click)="setActive('12')" class="menu" id="menu12"
                            *ngIf="token?.permissions?.centraldashboard">
                            <a routerLink="/centraldashboard" href="javascript:void(0);" data-toggle="collapse"
                                aria-expanded="true" class="dropdown-toggle">
                                <div class="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="feather feather-home">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                                    </svg>
                                    <span> Dashboard </span>
                                </div>
                            </a>
                        </li>

                    </ul>
                </nav>

            </div>
            <!--  END SIDEBAR  -->

            <!--  BEGIN CONTENT AREA  -->
            <div id="content" class="main-content">
                <div class="layout-px-spacing">


                    <!-- CONTENT AREA -->
                    <router-outlet></router-outlet>
                    <!-- CONTENT AREA -->

                </div>

                <app-footer></app-footer>
            </div>
            <!--  END CONTENT AREA  -->



        </div>
        <!-- END MAIN CONTAINER -->

    </div>
</div>